import { f as BarGaugeValueMode, d as BarGaugeSizing, g as BarGaugeNamePlacement, h as BarGaugeDisplayMode } from '../../../../../index-DuYVZf5J.js';

"use strict";
const pluginVersion = "13.0.0-pre";
const defaultOptions = {
  displayMode: BarGaugeDisplayMode.Gradient,
  maxVizHeight: 300,
  minVizHeight: 16,
  minVizWidth: 8,
  namePlacement: BarGaugeNamePlacement.Auto,
  showUnfilled: true,
  sizing: BarGaugeSizing.Auto,
  valueMode: BarGaugeValueMode.Color
};

export { defaultOptions, pluginVersion };
